/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import { call, put, takeLatest, all, takeEvery } from "redux-saga/effects";
import * as analyticActions from "./actions";
import * as datapipeActions from "../datapipe/actions";
import { collectorDataPipeBO } from "../datapipe/helper";
import { FetchAnalytics, FetchAAnalytic } from "./services";

// worker saga: makes the api call when watcher saga sees the action
export function* fetchAnalyticSaga(action) {
  try {
    const response = yield call(FetchAnalytics, action.payload);
    const analytics = response.data || {};
    // analytics.list = analytics.results;
    // delete analytics.results;
    yield put(analyticActions.FetchAnalyticsSuccess(analytics));
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(analyticActions.FetchAnalyticsFailed(error));
  }
}

export function* fetchAAnalyticSaga(action) {
  try {
    const response = yield call(FetchAAnalytic, action.payload);
    const analytic = response.data || {};
    yield put(analyticActions.FetchAAnalyticSuccess(analytic));
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(analyticActions.FetchAAnalyticFailed(error));
  }
}

export function* /* istanbul ignore next */ fetchAAnalyticPutToDatapipe(
  action,
) {
  /* istanbul ignore next */
  try {
    const response = yield call(FetchAAnalytic, action.payload.playerId);
    const analytic = response.data || {};
    yield put(analyticActions.FetchAAnalyticSuccess(analytic));
    yield put(
      datapipeActions.AddCollectorTODatapipe(
        collectorDataPipeBO(action.payload, analytic),
      ),
    );
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put(analyticActions.FetchAAnalyticFailed(error));
  }
}
// watcher saga: watches for actions dispatched to the store, starts worker saga
export function* analyticWatcher() {
  yield all([
    takeLatest(analyticActions.types.FETCH_ANALYTICS, fetchAnalyticSaga),
    takeEvery(
      analyticActions.types.FETCH_A_ANALYTIC_PUT_DATAPIPE,
      fetchAAnalyticPutToDatapipe,
    ),
    takeEvery(analyticActions.types.FETCH_A_ANALYTIC, fetchAAnalyticSaga),
  ]);
}
